import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { CalendarLinkService } from "src/app/Services/calendar-link.service";
import {
  downloadConsultationIcs,
  getConsultationCalendarEventPayload,
  openGoogleCalendarForConsultation,
} from "src/app/utils/consultation-calendar.util";

export type AddConsultationCalendarDialogData = {
  consultation: any;
};

export type ConsultationCalendarChoice = "google" | "outlook" | "ical";

@Component({
  selector: "app-add-consultation-calendar-dialog",
  templateUrl: "./add-consultation-calendar-dialog.component.html",
  styleUrls: ["./add-consultation-calendar-dialog.component.scss"],
})
export class AddConsultationCalendarDialogComponent {
  selected: ConsultationCalendarChoice = "google";

  readonly options: Array<{
    value: ConsultationCalendarChoice;
    label: string;
    hint: string;
    iconPath: string;
  }> = [
    {
      value: "google",
      label: "Google Calendar",
      hint: "Opens in a new tab",
      iconPath: "assets/icons/calendar-google.svg",
    },
    {
      value: "outlook",
      label: "Outlook Calendar (Microsoft 365)",
      hint: "Opens in a new tab",
      iconPath: "assets/icons/calendar-outlook.svg",
    },
    {
      value: "ical",
      label: "Apple Calendar & others (.ics)",
      hint: "Downloads a file",
      iconPath: "assets/icons/calendar-ical.svg",
    },
  ];

  constructor(
    private dialogRef: MatDialogRef<AddConsultationCalendarDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AddConsultationCalendarDialogData,
    private calendarLinkService: CalendarLinkService
  ) {}

  cancel(): void {
    this.dialogRef.close();
  }

  select(value: ConsultationCalendarChoice): void {
    this.selected = value;
  }

  addToCalendar(): void {
    const c = this.data?.consultation;
    if (!c) {
      this.dialogRef.close();
      return;
    }
    if (this.selected === "google") {
      openGoogleCalendarForConsultation(c);
    } else if (this.selected === "outlook") {
      const payload = getConsultationCalendarEventPayload(c);
      if (payload) {
        const url = this.calendarLinkService.buildOutlookCalendarLink({
          title: payload.title,
          details: payload.details,
          location: payload.location,
          start: payload.start,
          end: payload.end,
        });
        window.open(url, "_blank", "noopener,noreferrer");
      }
    } else {
      downloadConsultationIcs(c);
    }
    this.dialogRef.close();
  }
}
